import { render } from "./cloud-products.vue?vue&type=template&id=1b23c552&scoped=true"
import script from "./cloud-products.vue?vue&type=script&lang=js"
export * from "./cloud-products.vue?vue&type=script&lang=js"

import "./cloud-products.vue?vue&type=style&index=0&id=1b23c552&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b23c552"]])

export default __exports__